import React from 'react';
import './ProcessView.scss';
import { ChevronProcessDiagram } from '../../../AdminMarketplace/ChevronProcessDiagram/ChevronProcessDiagram';
import { TimelineEvent } from '../../../../slices/marketplace/timeline/models/timeline-event.model';
import { ChevronDiagramEvent } from '../../../AdminMarketplace/ChevronProcessDiagram/models/ChevronDiagramEvent';
import { LinkedDataRequestProject } from '../../../../slices/marketplace/timeline/models/linked-data-request-project.model';
import { EngagementBuyerActionState } from '../../../../slices/marketplace/timeline/models/engagement-buyer-action-state.model';

interface ProcessViewProps {
    timelineEvents: TimelineEvent[];
    dataRequestProjects?: LinkedDataRequestProject[];
    engagementStartDate: Date;
    onActionClick(item: ChevronDiagramEvent): void;
    isEventActionVisible: (eventId: string) => boolean;
    isTempoPreview?: boolean;
    engagementId: number;
    isBuyerView: boolean;
    hideExecuteButton?:boolean
    buyerActionState?: EngagementBuyerActionState[];
}

const ProcessView = (props: ProcessViewProps) => {
    return (
        <div className="process-view">
            <ChevronProcessDiagram
                timelineEvents={props.timelineEvents}
                dataRequestProjects={props.dataRequestProjects}
                engagementStartDate={props.engagementStartDate}
                onActionClick={props.onActionClick}
                isEventActionVisible={props.isEventActionVisible}
                isTempoPreview={props.isTempoPreview}
                engagementId={props.engagementId}
                isBuyerView={props.isBuyerView}
                hideExecuteButton={!!props.hideExecuteButton}
                buyerActionState={props.buyerActionState}
            />
        </div>
    );
};

export default ProcessView;
